export enum HorizontalScrollPace {
  Pace_1 = 2,
  Pace_2 = 6,
  Pace_3 = 15,
  Pace_4 = 25,
}

export type ScrollDirection = 'left' | 'right';
